export var IconSize;
(function (IconSize) {
    IconSize["medium"] = "medium";
    IconSize["small"] = "small";
})(IconSize || (IconSize = {}));
